import { DsPinsExportResponseInterface } from '../interfaces/ds-pins-export-response.interface';

/**
 * Class mapping the return object of a pins export by mail
 */
export class DsPinsExportResponse {
  mail: string;

  /**
   * Creates an instance of DsPinsExportResponse.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsPinsExportResponseInterface) {
    this.mail = jsonData.mail;
  }
}
